import { DifferenceProps } from '../DifferenceElementView';
import DifferenceDescription from '../DifferenceDescription/DifferenceDescription';
import { useSelector } from 'react-redux';
import { getIsStepAndRepeat, getSelectedModule } from 'store';
import { CTFModuleTypes, DocumentTypes } from 'types';
import DifferenceCardThumbnail, { type DifferenceCardThumbnailStatus } from './DifferenceCardThumbnail';
import DifferenceCardGraphics from './DifferenceCardGraphics';

const mergedThumbnailStatus = (thumbnailUrl?: string | null): DifferenceCardThumbnailStatus => {
  if (thumbnailUrl) return 'ready';
  if (thumbnailUrl === null) return 'noComparison';
  return 'loading';
};

const MergedGraphicDifference = ({ difference, multipleSelectionMode = false }: DifferenceProps) => {
  const isStepAndRepeat = useSelector(getIsStepAndRepeat);
  const selectedModule = useSelector(getSelectedModule);
  const differenceNumber = difference.differenceIndex;

  const sourcePageNumberText = `source (p${difference.source.location.pageNumber})`;
  const targetPageNumberText =
    isStepAndRepeat && selectedModule === CTFModuleTypes.graphics && difference.matchIndex !== undefined
      ? `new (Repeat ${difference.matchIndex + 1})`
      : `new (p${difference.target.location.pageNumber})`;

  const renderContent = (type: DocumentTypes) => {
    const thumbnailUrl = difference.thumbnailPaths?.[type]?.thumbnailUrl;
    return (
      <DifferenceCardThumbnail
        status={mergedThumbnailStatus(thumbnailUrl)}
        src={thumbnailUrl ?? undefined}
        alt={`${type.charAt(0).toUpperCase() + type.slice(1)} Merged Difference # ${differenceNumber}`}
        imgId={`${type}-thumbnail-${differenceNumber}`}
        credentialed
      />
    );
  };

  return (
    <DifferenceDescription
      difference={difference}
      media={
        <DifferenceCardGraphics
          source={renderContent(DocumentTypes.source)}
          target={renderContent(DocumentTypes.target)}
          sourceLabel={sourcePageNumberText}
          targetLabel={targetPageNumberText}
        />
      }
      multipleSelectionMode={multipleSelectionMode}
    />
  );
};

export default MergedGraphicDifference;
